import { worldCountries } from 'sonata-static-storage/lib/samples/worldCountries.samples';

import { useTargetingContext } from '@/contexts/Targeting/TargetingContext';
import { AudienceProfileModal } from '../../components/AudienceProfileModal';

type Props = {
  defaultSelectedItems: Record<string, boolean>;
  isModalOpened: boolean;
  onModalClose: () => void;
  onModalSave: (items: Record<string, any>[]) => void;
  theme?: 'light' | 'dark';
};

function VenueVisitsModal({ defaultSelectedItems, isModalOpened, onModalClose, onModalSave, theme = 'light' }: Props) {
  const { user } = useTargetingContext();

  const parseData = (res: { items: Record<string, any>[] }) =>
    res?.items?.map(item => {
      const { lat, lng } = item.latlng;
      const country = worldCountries.find(wc => wc.cca2.toLowerCase() === item.country)?.name.common;
      return {
        ...item,
        id: item._id.toString(),
        name: `${item.name}${country ? ` - ${country}` : ''} - ${lat}, ${lng}`
      };
    }) || [];

  const formatRequestArgs = (page: number, size: number, filterText: string | null | undefined) => ({
    data: {
      filterAddedShops: [],
      filterIncludeShopTile: false,
      filterString: filterText,
      limit: size,
      order: 'desc',
      page: page + 1,
      sortBy: 'created'
    },
    method: 'POST'
  });

  return (
    <AudienceProfileModal
      defaultSelectedItems={defaultSelectedItems}
      formatRequestArgs={formatRequestArgs}
      isModalOpened={isModalOpened}
      onModalClose={onModalClose}
      onModalSave={onModalSave}
      parseData={parseData}
      tableConfig={{
        toolbar: { showSelectAll: true }
      }}
      tableProps={{}}
      theme={theme}
      url={`${taptap.config.sonataBackendUrl}shops/${user._id}`}
    />
  );
}

export default VenueVisitsModal;
